import PropTypes from 'prop-types';
// @mui
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
// theme
import { hideScroll } from 'src/theme/css';
// hooks
import { NavSectionMini } from 'src/components/nav-section';
import Logo from 'src/components/logo';
//
import { HEADER, NAV } from '../config-layout';
import { useNavData } from './config-navigation';
import { NavToggleButton } from '../_common';

// ----------------------------------------------------------------------

export default function NavMini({sx}) {
  const navData = useNavData();

  return (
    <Box
      component="nav"
      sx={{
        flexShrink: { lg: 0 },
        width: { lg: NAV.W_MINI },
      }}
    >
      <NavToggleButton
        sx={{
          top: 38,
          left: NAV.W_MINI - 12,
        }}
      />

      <Stack
        sx={{
          pb: 2,
          bottom: 0,
          position: 'fixed',
          top: { lg: HEADER.H_DESKTOP },
          width: NAV.W_MINI,
          bgcolor: 'background.paper',
          borderRight: (theme) => `dashed 1px ${theme.palette.divider}`,
          ...hideScroll.x,
          ...hideScroll.y,
        }}
      >
        <NavSectionMini data={navData} sx={{ pt: 1.5 }} />
      </Stack>
    </Box>
  );
}
NavMini.propTypes = {
  sx: PropTypes.object,
};
